import React from 'react'
import Header from '../Menpages/Header/Main'
import Footer from '../Menpages/Footer/Main'
import Bredcom from '../Menpages/Bredcom/Main'
import Latest from '../Menportfolio/Latest'
import Slider from '../Menpages/GlobleSlider/Main'

function Main() {
  return (
   <>
        <div className="page-wrapper">
            <Header/>
            <Bredcom title={"Home"} head={"Portfolio Grid"} sbtitle={"Portfolio Grid"}/>
            <Latest/>
            <Slider/>
            <Footer/>
        </div>
   </>
  )
}

export default Main